import { render, staticRenderFns } from "./ProductDialog.vue?vue&type=template&id=625e91a4&scoped=true&"
import script from "./ProductDialog.vue?vue&type=script&lang=ts&"
export * from "./ProductDialog.vue?vue&type=script&lang=ts&"
import style0 from "./ProductDialog.vue?vue&type=style&index=0&id=625e91a4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "625e91a4",
  null
  
)

export default component.exports